import CalendarEventIcon from './CalendarEventIcon';

export default CalendarEventIcon;
